import { createClients } from 'client-shared/api/client'
import { HOST } from '../constants'

export const clients = createClients(HOST.API)
